const commentItems = [
  {
    avatar: '吃瓜群众A',
    time: '3小时前',
    content: '每日大赛黑料的更新速度真的绝了，刚发生的事这边就已经安排上了！黑料吃瓜群里的信息更劲爆，强烈推荐加入。大赛吃瓜只服这个站，其他地方的信息都没这里快。',
    likes: '2.3k',
  },
  {
    avatar: '八卦研究员',
    time: '5小时前',
    content: '作为资深吃瓜爱好者，我跟了很多大赛内幕平台，每日大赛黑料的信息准确率是最高的。虽然有时候标题有点夸张，但干货确实多。每日吃瓜爆料的质量有保障，黑料围观体验拉满。',
    likes: '1.8k',
  },
  {
    avatar: '理性吃瓜人',
    time: '8小时前',
    content: '这个站的黑料吃瓜做得挺专业的，不是那种纯标题党。大赛八卦的深度解析很有料，而且更新频率高。每日黑料最新消息基本都能在这里第一时间看到，吃瓜群众的快乐源泉。',
    likes: '1.1k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜评论
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            吃瓜群众的真实声音，来自每日大赛黑料社区
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 text-xs font-bold">
                    {item.avatar.slice(0, 2)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{item.avatar}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {item.content}
              </p>
              <div className="mt-3 flex items-center gap-4">
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}